// Centralized query keys for React Query
export const variableComplexityPolicyKeys = {
  // Planner related queries
  planner: {
    variableComplexityPolicy: () =>
      ['planner', 'variable-complexity-policy'] as const,
    updateVariableComplexityPolicy: () =>
      ['planner', 'update-variable-complexity-policy'] as const,
    variableComplexityServices: () =>
      ['planner', 'variable-complexity-services'] as const,
    recomputeVariableComplexityThreshold: () =>
      ['planner', 'recompute-variable-complexity-threshold'] as const,
    backfillVariableComplexity: () =>
      ['planner', 'backfill-variable-complexity'] as const,
  },
} as const;
